import dayjs, { Dayjs } from 'dayjs';
import { translateDateIntoIsoString } from './index';

interface CreateStartDateConfig {
  startDayjs?: Dayjs;
  daysNumber?: number;
  timezone?: string;
}

/**
 * Creates a startDate array for P4RContext
 * @param config - Configuration object
 * @param config.startDayjs - The starting date/time (defaults to now)
 * @param config.daysNumber - Number of days ahead for end date (default: 4)
 * @param config.timezone - Timezone offset (default: '+00:00')
 * @returns [Dayjs, startISO, endISO, timezone] tuple for P4RContext
 */
export const createStartDate = ({
  startDayjs = dayjs(),
  daysNumber = 4,
  timezone = '+00:00',
}: CreateStartDateConfig = {}): [Dayjs, string, string, string] => {
  const day = startDayjs.utcOffset(timezone);
  const start = translateDateIntoIsoString(
    startDayjs.utcOffset(timezone).startOf('hour'),
  );
  const end = translateDateIntoIsoString(
    startDayjs.add(daysNumber, 'day').utcOffset(timezone).endOf('day'),
  );

  return [day, start, end, timezone];
};

/**
 * Normalizes a date to ISO date string at start of day for consistent lookups
 * @param date - Dayjs object or ISO date string
 * @returns ISO date string in format "YYYY-MM-DDTHH:mm:ss+00:00" at start of day
 */
export function normalizeDateString(date: Dayjs | string | null | undefined): string {
  if (!date) return '';
  const dayjsDate = typeof date === 'string' ? dayjs.utc(date) : date;
  return translateDateIntoIsoString(dayjsDate.startOf('day'));
}
